import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignInIcon from "../../assets/signInIcon.png";
import Card from "../../components/Card/Card";
import { useSelector, useDispatch } from "react-redux";
import { authLogin } from "../../utils/auth_service/AuthServiceHelper";
import { tokenRefreshed } from "../../Redux/Action/token.action";
import { toast } from "react-toastify";
import { APPLICATION_NAME } from "../../utils/Constant";

function SignIn() {
  const [formData, setFormData] = useState({ email: "", password: "", role :"" });
  const [isEmailEmply, setIsEmailEmply] = useState(true);
  const [isPasswordEmply, setIsPasswordEmply] = useState(true);
  const [isRoleEmply, setIsRoleEmply] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChangeHandler = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    switch (name) {
      case "email":
        setFormData({ ...formData, [name]: value });
        value?.trim() === "" ? setIsEmailEmply(true) : setIsEmailEmply(false);
        break;

      case "password":
        setFormData({ ...formData, [name]: value });
        value?.trim() === ""
          ? setIsPasswordEmply(true)
          : setIsPasswordEmply(false);
        break;

      case "role":
        setFormData({ ...formData, [name]: value });
        value?.trim() === ""
          ? setIsRoleEmply(true)
          : setIsRoleEmply(false);
        break;

      default:
        break;
    }
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    setIsLoading(true);
    console.log("SUBMIT");

    const config = {
      url: "api/v1/oauth/getToken",
      method: "post",
      data: {
        username: formData.email,
        password: formData.password,
        role: formData.role,
        grantType: "password"
      },
    };
    authLogin(config)
      .then((response) => {
        console.log(response)
    setIsLoading(false);
        dispatch(tokenRefreshed());

    const authorities = response.authorities || []; 
    const hasRole = authorities.some((role) => role.authority === formData.role);

    if (hasRole){
      if( formData.role ==="Manager"){
        toast.success("LoggedIn Successfully!");
        navigate(`/${APPLICATION_NAME}/manager`);
      }else if(formData.role ==="Curator"){
        toast.success("LoggedIn Successfully!");
        navigate(`/${APPLICATION_NAME}/select-project`);
      }
      }else {
      // Show error message
      console.error(`Role "${formData.role}" not found!`);
      alert(`You do not have the required role: ${formData.role}`);
    }
    })
      .catch((error) => {
    setIsLoading(false);
    const errorMessage =  error.response;
        toast.error(
          errorMessage.data.error_description
            ? errorMessage.data.error_description
            : "Invalid Role"
        );
        console.log("Error =>", errorMessage.data.error_description);
      });
  };

  console.log("formData =>", formData);
  return (
    <Card>
      <div className="text-center  mb-1 mt-10">
        <div className="mx-auto w-25">
          <img src={SignInIcon} className="w-75" />
        </div>
        <h4 className="mt-3">Sign In</h4>
        <p className="text-muted">Enter your profile details to sign in</p>
      </div>

      {/* LOGIN FORM */}
      <form onSubmit={onSubmitHandler}>
        <div className="form-group mb-2 text-start">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            placeholder="Enter your email"
            onChange={onChangeHandler}
            name="email"
          />
        </div>
        <div className="form-group mb-2 text-start">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Password"
            onChange={onChangeHandler}
            name="password"
          />
        </div>
        <div className="form-group mb-2 text-start">
          <label htmlFor="role" className="form-label">
            Role
          </label>
          <select className="form-select" id="role" onChange={onChangeHandler} name="role">
          <option value={""}>-- Select --</option>
            <option value={"Curator"}>Curator</option>
            <option value={"Manager"}>Manager</option>
          </select>
         
        </div>
        <button
          className="btn btn-primary w-100 mb-2 mt-1"
          type="submit"
          disabled={isEmailEmply || isPasswordEmply || isRoleEmply ? true : false}
        >
          Sign In
        </button>
        <div className="text-center">
          <a href="#" className="text-primary text-decoration-none">
            Forgot password
          </a>
        </div>
      </form>
    </Card>
  );
}

export default SignIn;
